module.exports = __webpack_public_path__ + "img/onion.2a0ca17b.png";